/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import LoadIcon from '@material-ui/icons/Refresh';
import ErrorComponent from '../ErrorComponent';
import './HTMLTourView.scss';

const LoadingIcon = () => (
  <LoadIcon
    className="grb-doc-component-loading-icon"
    style={{
      animation: 'Rotate 5s infinite linear',
      fontSize: 40,
    }}
  />
);

const processDocContent = (doccontent) => {
  const index = doccontent.indexOf('<main>');
  let content;
  if (index >= 0) {
    const last = doccontent.lastIndexOf('</main>');
    if (last > 0) {
      content = doccontent.substring(index, last + 7);
    } else {
      content = doccontent.substring(index);
    }
  } else {
    content = doccontent.substring(0);
  }

  return content;
};

const HTMLTourView = (props) => {
  const { url } = props;
  const [{ loading, innerHTML, error }, setPage] = useState({ loading: true });
  useEffect(() => {
    setPage({ loading: true });
    axios.get(url)
    .then((res) => {
      const innerHTML = {
        __html: processDocContent(res.data),
      };
      setPage({ innerHTML });
    })
    .catch((e) => {
      setPage({ error: e });
    });
  }, [url]);

  if (loading) {
    return (
      <div className="grb-html-view">
        <div className="grb-html-view-loading">
          <LoadingIcon />
          <Typography variant="h5">{`Loading page ${url}`}</Typography>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="grb-html-view">
        <Paper className="grb-html-view-error">
          <ErrorComponent title={`Error loading ${url}`} error={error} />
        </Paper>
      </div>
    );
  }

  return (
    <div className="grb-html-view" dangerouslySetInnerHTML={innerHTML} />
  );
};

HTMLTourView.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
};

HTMLTourView.defaultProps = {
  title: 'tour view',
};

export default HTMLTourView;
